<template>
    <div class="modal-custom-black" :id="modalId" v-if="showModal">
        <div class="modal-custom-black-content">
            <div class="modal-custom-black-header">
                <span class="modal-custom-black-close" v-if="!hideTopCloseButton" @click="hideModal">&times;</span>
            </div>
            <div class="modal-custom-black-body text-center d-flex flex-column justify-content-center">
                <slot></slot>
            </div>
        </div>
    </div>
</template>

<script>

const data = () => {
    return {
        showModal: false,
        $: null,
    }
}

function created() {
    if (typeof $ !== "undefined") {
        this.$ = $;
    }
}

function mounted() {
    this.showModal = true;

    this.disableScroll();
}

function disableScroll() {
    this.$(() => {
        if (this.$('body').length) {
            this.$('body').addClass('disable-scroll');
        }
    })
}

function enableScroll() {
    this.$(() => {
        if (this.$('body').length) {
            this.$('body').removeClass('disable-scroll');
        }
    })
}

function hideModal() {
    this.showModal = false;
    this.enableScroll();
}

export default {
    data,
    created,
    mounted,
    computed: {
        ...mapState(['translate'])
    },
    methods: {
        disableScroll,
        enableScroll,
        hideModal,
    },
    props: ['modalId', 'hideTopCloseButton'],
    beforeDestroy() {
        this.enableScroll();
    }
}
</script>
